module.exports = __webpack_public_path__ + "static/media/cancelOrder.a0e614c8.png";